import { render, staticRenderFns } from "./PlayerPendingAddDataInputForceApplyMigration.vue?vue&type=template&id=2e2446a7&"
import script from "./PlayerPendingAddDataInputForceApplyMigration.vue?vue&type=script&lang=js&"
export * from "./PlayerPendingAddDataInputForceApplyMigration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports